import Cookies from 'js-cookie'


function getCookies(TokenKey) {
  return Cookies.get(TokenKey)
}

function setCookies(TokenKey,token) {
  return Cookies.set(TokenKey, token)
}

function removeCookies(TokenKey) {
  return Cookies.remove(TokenKey)
}


export default{
  getCookies,
  setCookies,
  removeCookies
}



// WEBPACK FOOTER //
// ./src/auth.js